import React from 'react'
import styled from 'styled-components'
import { Select } from '@nv/react-akira'
import { LOGIN_METHOD_OPTIONS } from './LoginForm.constants'
import { mapOptionsArrayToSelectItem } from 'utils/selectMappers'
import { FormattedMessage } from 'react-intl'
import { useStorage, useTranslateOptionItems } from 'hooks'
import { AKIRA_QUERIES } from 'themes/media'
import { SubmitButton } from 'components/SubmitButton'
import { EmailLogin } from 'containers/LoginForm/LoginForm.EmailLogin'
import { PhoneLogin } from 'containers/LoginForm/LoginForm.PhoneLogin'
import { Header } from 'containers/LoginForm/LoginForm.Header'
import { SIGNUP_METHOD } from '../SignUpWrapper/SignUpWrapper.constants'
import { FieldWrapper } from '../../components/FieldWrapper'
import { useNinjaURLParams } from 'hooks'

export const LoginForm = () => {
  const loginMethodOptions = useTranslateOptionItems(LOGIN_METHOD_OPTIONS)
  const [loginMethod, setLoginMethod] = useStorage('loginMethod', loginMethodOptions[0], 'session')
  useNinjaURLParams()
  return (
    <Wrapper>
      <Header />

      <MethodSelectWrapper>
        <FieldWrapper>
          <Select
            name='method'
            label={<FormattedMessage id='auth.logging_in_with' />}
            by='value'
            value={loginMethod}
            onChange={setLoginMethod}
          >
            {mapOptionsArrayToSelectItem(loginMethodOptions)}
          </Select>
        </FieldWrapper>
      </MethodSelectWrapper>

      {loginMethod.value === SIGNUP_METHOD.EMAIL ? <EmailLogin /> : <PhoneLogin />}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  --gutter: 8px;

  @media ${AKIRA_QUERIES.laptopAndUp} {
    ${SubmitButton} {
      align-self: end;
      min-width: 100px;
    }
  }
`

const MethodSelectWrapper = styled.div`
  margin-bottom: var(--gutter);
`

export default LoginForm
